





































import { Component, Vue, Prop } from 'vue-property-decorator'

// jQuery
import $ from 'jquery'

// constants
import { extensions_default } from '@/constants'

// utils
import { toBase64 } from '@/utils'

// models
import { ImageForm } from '@/models'

@Component({
  name: 'DropifyFile'
})
export default class DropifyFile extends Vue {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    @Prop() readonly label!: string
    @Prop({ default: null }) readonly id!: string | number
    @Prop({ default: '' }) readonly name!: string
    @Prop({ default: null }) readonly defaultFile!: ImageForm
    @Prop({ default: 1, type: Number }) readonly maxFiles!: number
    @Prop({ default: false, type: Boolean }) readonly isMultiple!: boolean
    @Prop({ default: 300, type: Number }) readonly height!: number
    @Prop({ default: '2M', type: String }) readonly maxFileSize!: string
    @Prop({ default: null, type: Number }) readonly minWidth!: number|null
    @Prop({ default: null, type: Number }) readonly maxWidth!: number|null
    @Prop({ default: null, type: Number }) readonly minHeight!: number|null
    @Prop({ default: null, type: Number }) readonly maxHeight!: number|null
    @Prop({ default: false, type: Boolean }) readonly disabled!: boolean
    @Prop({ default: false, type: Boolean }) readonly required!: boolean
    @Prop({ default: false, type: Boolean }) readonly showRemove!: boolean
    @Prop({ default: false, type: Boolean }) readonly showLoader!: boolean
    @Prop({ default: 'outside', type: String }) readonly errorsPosition!: string
    @Prop({ default: extensions_default.join(' '), type: String }) readonly allowedFileExtensions!: string
    @Prop({ default: '10M', type: String }) readonly maxFileSizePreview!: string
    @Prop({ default: '', type: String }) readonly msgError!: string
    @Prop({ default: null }) readonly hasError!: boolean|null

    dropify: any = null
    idDropify: number|string|null = null
    extensions = []
    messagesDropify = {
        default: 'Arrastre el archivo o click para agregar',
        replace: 'Remplazar archivo',
        remove: 'Remover',
        error: 'Ooops, Se ha producido un error'
    }

    errorDropify = {
        fileSize: 'El tamaño del archivo es muy grande ({{ value }} max).',
        minWidth: 'El ancho del archivo es muy pequeño ({{ value }}px min).',
        maxWidth: 'El  ancho del archivo es muy grande ({{ value }}px max).',
        minHeight: 'El alto del archivo es muy pequeño ({{ value }}px min).',
        maxHeight: 'El alto del archivo es muy grande ({{ value }}px max).',
        imageFormat: 'El formato del archivo es inválido ({{ value }} solo).'
    }

    files: any = null
    sizeValues = {
        b: 1,
        kb: 1024,
        mb: 1024 * 1024
    }

    sizeUnit = 'mb'
    showErrors = true

    created () {
        const id_default = Math.random().toString(36).substring(7) + '-' + Math.floor(Math.random() * (101))
        if (!this.id) {
            this.idDropify = id_default
        } else {
            this.idDropify = this.id
        }
    }

    mounted () {
        this.dropify = null
        setTimeout(() => {
            this.dropify = $('#' + this.idDropify).dropify({
                messages: this.messagesDropify,
                error: this.errorDropify
            })
            this.dropify.on('dropify.afterClear', (/* event: any, element: any */) => {
                this.deleteItem(/* event, element */)
            })
        }, 500)
    }

    deleteItem (/* event: any, element: any */) {
        if (this.isMultiple) {
            // this.file
        }
        this.$emit('change', null)
    }

    async changeFile (e: any) { // validate files before add them to dropify zone
        const files = e.target.files || e.dataTransfer.files
        const tmpObj: any = {}
        for (let i = 0; i < files.length; i++) {
            tmpObj[i] = {}
        }
        this.files = {
            ...tmpObj
        }
        if (this.isMultiple) {
            // Funciones para multiple archivos en futuro
        } else {
            const base64 = await toBase64(files[0])
            if (files[0]?.name) {
                const file = {
                    filename: files[0].name,
                    file_type: files[0].type,
                    file_size: files[0].size,
                    dataURL: base64
                }
                return this.$emit('change', file)
            } else {
                return this.$emit('change', null)
            }
        }
    }

    get file () {
        if (this.defaultFile && this.defaultFile.dataURL) {
            return this.defaultFile.dataURL
        }
        return null
    }
}
